import React, { Fragment, PureComponent, memo } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { Tiempos_Lista, Tiempo_Modificar } from "../../request/MantenimientosRequest";
import { Notificacion } from "../../components/Util/Notificacion/Notificacion";
import TiemposIntfz from "./Interfaz/tiemposIntfz.jsx";

class tiempos extends PureComponent {
  _isMounted = false;

  state = {
    Datos: {
      titulo: "Lista de Tiempos",
    },
    listaTiemposOrig: [],
    listaTiempos: [],
    selectedTiempo: 0,
    disabled: {
      Acciones: true,
      HabilitarAplicar: "",
    },
    buscar: "",
  };

  componentDidMount = async () => {
    this._isMounted = true;

    let response = await Tiempos_Lista(this.props.token, this.props.empresa.Id);

    if (response.Exitoso) {
      this._isMounted &&
        this.setState({
          listaTiempos: response.Datos,
          listaTiemposOrig: response.Datos
        });
    } else {
      Notificacion.error(response.Mensaje);
    }
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  validaSeleccionado = () => {
    let id = this.state.selectedTiempo;
    if (id) {
      return true;
    } else {
      Notificacion.error("Debe seleccionar un registro");
      return false;
    }
  };

  guardarTiempo  = async (newValue, row) => {
    let response = await Tiempo_Modificar(
      this.props.token,
      this.props.empresa.Id,
      row.Estatus_Id,
      row.Nombre,
      "1900-01-01 " + newValue,
      row.Cambio
    );

    if (response.Exitoso) {
      Notificacion.success("Se actualizó la información con éxito");

      response = await Tiempos_Lista(this.props.token, this.props.empresa.Id);

      if (response.Exitoso) {
        this._isMounted &&
          this.setState({
            listaTiempos: response.Datos,
            listaTiemposOrig: response.Datos,
          });
      } else {
        Notificacion.error(response.Mensaje);
      }
    } else {
      Notificacion.error("Error: " + response.Mensaje);
    }
  };

  ingresarDatos = (newValue, row, column) => {
    if (newValue !== "00:00:00") {
      this.guardarTiempo(newValue, row);
    } else {
      return false;
    }

    return true;
  }

  onRowSelect = (row, isSelected) => {
    this.state.disabled.Acciones = false;
    this.state.selectedTiempo = row.Estatus_Id;
  };

  filtrarRegistro = (event) => {
    const { listaTiemposOrig } = this.state;

    if (event.key !== "Enter") return;

    if (this._isMounted) {
      this.setState({
        buscar: event.target.value,
      });
    }

    let result = [];

    if (event.target.value.trim().length > 0) {
      result = listaTiemposOrig.filter(
        (item) =>
          item.Nombre.toUpperCase().indexOf(
            event.target.value.toUpperCase().trim()
          ) != -1
      );

      if (result.length > 0) {
        if (this._isMounted) {
          this.setState({ listaTiempos: result });
        }
      } else {
        result = listaTiemposOrig.filter(
          (item) => item.Estatus_Id == event.target.value.trim()
        );

        if (result.length > 0) {
          if (this._isMounted) {
            this.setState({ listaTiempos: result });
          }
        }
      }
    } else {
      if (this._isMounted) {
        this.setState({ listaTiempos: listaTiemposOrig });
      }
    }
  };

  onFocusInput = (event) => {
    event.target.value = this.state.buscar;
  };

  render() {
    const { Datos, listaTiempos } = this.state;

    return (
      <Fragment>
        <TiemposIntfz
          listaTiempos={listaTiempos}
          Datos={Datos}
          onRowSelect={this.onRowSelect}
          ingresarDatos={this.ingresarDatos}
          filtrarRegistro={this.filtrarRegistro}
          onFocusInput={this.onFocusInput}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.usuario.token,
    empresa: state.parametros.empresa,
    callCenter: state.parametros.callCenter,
  };
};

export default connect(mapStateToProps)(withRouter(memo(tiempos)));
